/**************** USER CONTROL ACCESS PAGE START *********************** */
export const userControlAccessPageMenu = {
	userControlAccessPages: {
		id: 'userControlAccess',
		text: 'User Control Access',
		path: '/userControlAccess',
		icon: 'Inbox',
		isView: true,
		subMenu: {
			assignUserRights: {
				id: 'assignUserRights',
				text: 'Assign User Rights',
				path: '/user-Control-Access/assign-user-rights',
				icon: 'list',
				isView: true,
			},
			memberMandatoryAccess: {
				id: 'memberMandatoryAccess',
				text: 'Member Mandatory Access',
				path: '/user-Control-Access/member-Mandatory-Access',
				icon: 'list',
				isView: true,
			},
			workFlowManagement: {
				id: 'workFlowManagement',
				text: 'Work Flow Management',
				path: '/user-Control-Access/work-flow-management',
				icon: 'list',
				isView: true,
			},
			highmarkRules: {
				id: 'highMarkRules',
				text: 'HighMark Rules',
				path: '/user-Control-Access/highMark-Rules',
				icon: 'list',
				isView: true,
			},
			// ruleEngine: {
			// 	id: 'ruleEngine',
			// 	text: 'Rule Engine',
			// 	path: '/user-Control-Access/ruleEngine',
			// 	icon: 'list',
			// 	isView: true,
			// },
		},
	},
};
/**************** USER CONTROL ACCESS PAGE END *********************** */

/**************** COMAPNY PAGE MENU START *********************** */
export const companyPageMenu = {
	pages: {
		id: 'company',
		text: 'Company',
		icon: 'Apartment',
	},
	companyPages: {
		id: 'companyPage',
		text: 'Company',
		path: 'company-pages',
		icon: 'Apartment',
		subMenu: {
			companyPage: {
				id: 'companyPage',
				text: 'Company',
				path: 'company-pages/company',
				icon: 'Apartment',
			},
		},
	},
};
/**************** COMAPNY PAGE MENU END *********************** */

/**************** MASTER PAGE MENU START *********************** */
export const masterPageMenu = {
	masterPages: {
		id: 'masterPages',
		text: 'Master',
		path: 'master-pages',
		icon: 'AutoStories',
		subMenu: {
			branchPage: {
				id: 'branchPage',
				text: 'Branch',
				path: 'master-pages/branch',
				icon: 'AddBusiness',
			},
			centerPage: {
				id: 'centerPage',
				text: 'Center',
				path: 'master-pages/Center',
				icon: 'Apartment',
			},
			rolePage: {
				id: 'rolePage',
				text: 'Role',
				path: 'master-pages/Role',
				icon: 'GroupAdd',
			},
			staffPage: {
				id: 'staffPage',
				text: 'Staff',
				path: 'master-pages/Staff',
				icon: 'SupervisedUserCircle',
			},
			savingsPage: {
				id: 'savings',
				text: 'Loan Advance',
				path: 'master-pages/savings',
				icon: 'MonetizationOn',
			},
			memberPage: {
				id: 'member',
				text: 'Member',
				path: 'master-pages/member',
				icon: 'PeopleAlt',
			},
			group: {
				id: 'group',
				text: 'Group',
				path: '/master-pages/group',
				icon: 'PeopleAlt',
			},
			insurance_company: {
				id: 'insurance_company',
				text: 'Insurance Company',
				path: '/master-pages/insurance_company',
				icon: 'AccountTree',
			},
			fetchProductType: {
				id: 'fetchProductType',
				text: 'Product Type',
				path: '/master-pages/fetchProductType',
				icon: 'DonutSmall',
			},
			product: {
				id: 'product',
				text: 'Product',
				path: '/master-pages/product',
				icon: 'Grain',
			},
			funderPage: {
				id: 'funder',
				text: 'Funder',
				path: '/master-pages/funder',
				icon: 'OfflineBolt',
			},
			economicActivityType: {
				id: 'economicActivityType',
				text: 'Economic Activity Type',
				path: '/master-pages/economic-Activity-Type',
				icon: 'VolunteerActivism',
			},
			economicActivity: {
				id: 'economicActivity',
				text: 'Economic Activity',
				path: '/master-pages/economicActivity',
				icon: 'LocalActivity',
			},
			purposeOfLoanTypePage: {
				id: 'purposeOfLoanTypePage',
				text: 'Purpose Of Loan Type',
				path: 'master-pages/purposeOfLoanTypePage',
				icon: 'LocalActivity',
			},
			purposeOfLoanPage: {
				id: 'purposeOfLoanPage',
				text: 'Purpose Of Loan',
				path: 'master-pages/purposeOfLoanPage',
				icon: 'VolunteerActivism',
			},
			questionnaire: {
				id: 'questionnaire',
				text: 'Questionnaire',
				path: '/master-pages/questionnaire',
				icon: 'LocalActivity',
			},
			business: {
				id: 'business',
				text: 'Business',
				path: '/master-pages/business',
				icon: 'LocalActivity',
			},
			dealer: {
				id: 'dealer',
				text: 'Dealer',
				path: '/master-pages/dealer',
				icon: 'People',
			},
			// business_fund: {
			// 	id: 'business_fund',
			// 	text: 'Business Fund',
			// 	path: '/master/business_fund',
			// 	icon: 'MonetizationOn',
			// },
		},
	},
};
/**************** MASTER PAGE MENU END *********************** */

/**************** OPEARTION PAGE MENU START *********************** */
export const operationsPageMenu = {
	operationPages: {
		id: 'operations',
		text: 'Operations',
		path: '/operations',
		icon: 'Inbox',
		isView: true,
		subMenu: {
			funderDetails: {
				id: 'funderDetails',
				text: 'Funder Details',
				path: '/operations/funderDetails',
				icon: 'Money',
				isView: true,
			},
			auditTool: {
				id: 'auditTool',
				text: 'Auditing Tool',
				path: '/operations/auditTool',
				icon: 'QuestionAnswer',
				isView: true,
			},
			lineSeparatorStart: {
				id: 'lineSeparatorStart',
				text: '────────────────────',
				icon: undefined,
				isView: true,
			},
			loanProposalHead: {
				id: 'loanProposalHead',
				text: 'LOAN PROPOSAL',
				icon: undefined,
				isView: true,
				className: 'menu-header-large',
			},
			CenterWiseLoanProposal: {
				id: 'CenterWiseLoanProposal',
				text: 'Center Wise Loan',
				path: '/loanProposalPages/centerWiseLoanProposal',
				icon: 'AccountBalance',
				isView: true,
			},
			// ProductLoanProposal: {
			// 	id: 'ProductLoanProposal',
			// 	text: 'Product Loan',
			// 	path: '/loanProposalPages/ProductLoanProposal',
			// 	icon: 'Apartment',
			// },
			GroupWiseLoanProposal: {
				id: 'GroupWiseLoanProposal',
				text: 'Group Wise Loan',
				path: '/loanProposalPages/groupWiseLoanProposal',
				icon: 'Groups',
			},
			// CustomProductLoanProposal: {
			// 	id: 'CustomProductLoanProposal',
			// 	text: 'Custom Product Loan',
			// 	path: '/loanProposalPages/CustomProductLoanProposal',
			// 	icon: 'Apartment',
			// 	isView: true,
			// },
			RangeLoanProposal: {
				id: 'RangeLoanProposal',
				text: 'Range Product Loan',
				path: '/loanProposalPages/RangeLoanProposal',
				icon: 'BarChart',
			},
			IndividualLoanProposal: {
				id: 'IndividualLoanProposal',
				text: 'Individual Loan',
				path: '/loanProposalPages/IndividualLoanProposal',
				icon: 'Person',
			},

			GoldLoanProposal: {
				id: 'GoldLoanProposal',
				text: 'Gold Loan',
				path: '/loanProposalPages/GoldLoanProposal',
				icon: 'MonetizationOn',
				isView: true, // This will be controlled dynamically
			},
			BusinessLoanProposal: {
				id: 'BusinessLoanProposal',
				text: 'Business Loan Proposal',
				path: '/loanProposalPages/BusinessLoanProposal',
				icon: 'Store',
				isView: true,
			},
			autoLoanProposalPage: {
				id: 'autoLoanProposalPage',
				text: 'Auto Loan Proposal',
				path: '/loanProposalPages/AutoLoanProposal',
				icon: 'ElectricBike',
				isView: true,
			},
			RDProposal: {
				id: 'RDProposal',
				text: 'RD Proposal',
				path: '/loanProposalPages/RDProposal',
				icon: 'Savings',
				isView: true,
			},
			lineSeparator: {
				id: 'lineSeparator',
				text: '────────────────────',
				icon: undefined,
				isView: true,
			},
			loanDisbursement: {
				id: 'Loan Disbursement',
				text: 'Loan Disbursement',
				icon: undefined,
				isView: true,
				className: 'menu-header-large',
			},
			loanIndexDisbursementPage: {
				id: 'loanIndexDisbursementPage',
				text: 'Loan Disbursement',
				path: '/loanDisbursementPage/loanIndexDisbursement',
				icon: 'DoneAll',
			},
			businessLoanDisbursementPage: {
				id: 'businessLoanDisbursementPage',
				text: 'Business Loan Disbursement',
				path: '/loanDisbursementPage/businessLoanDisbursement',
				icon: 'Business',
			},
			goldLoanDisbursementPage: {
				id: 'goldLoanDisbursementPage',
				text: 'Gold Loan Disbursement',
				path: '/loanDisbursementPage/GoldLoanDisbursement',
				icon: 'GppGood',
			},
			autoLoanDisbursemetPage: {
				id: 'autoLoanDisbursemetPage',
				text: 'Auto Loan Disbursement',
				path: '/loanDisbursementPage/autoLoanDisbursement',
				icon: 'CarRental',
			},
			collectionLineSeparatorStart: {
				id: 'collectionLineSeparatorStart',
				text: '────────────────────',
				icon: undefined,
				isView: true,
			},
			loanCollectionHead: {
				id: 'loanCollectionHead',
				text: 'COLLECTION',
				icon: undefined,
				isView: true,
				className: 'menu-header-large',
			},
			demandCollectionPage: {
				id: 'demandCollectionPage',
				text: 'Demand Collection',
				path: '/collectionPages/demandCollection',
				icon: 'Collections',
			},
			advanceCollectionPage: {
				id: 'advanceCollectionPage',
				text: 'Advance Collection',
				path: '/collectionPages/advanceCollectionPage',
				icon: 'NextWeek',
			},
			memberCollectionPage: {
				id: 'memberCollectionPage',
				text: 'Member Collection',
				path: '/collectionPages/memberCollection',
				icon: 'People',
			},
			arrearCollectionPage: {
				id: 'arrearCollectionPage',
				text: 'Arrear Collection',
				path: '/collectionPages/arrearCollectionPage',
				icon: 'Preview',
			},
			businessCollectionPage: {
				id: 'businessCollectionPage',
				text: 'Business Loan Collection',
				path: '/collectionPages/businessCollection',
				icon: 'Business',
			},
			goldCollectionPage: {
				id: 'goldCollectionPage',
				text: 'Gold Loan Collection',
				path: '/collectionPages/goldCollectionPage',
				icon: 'BrightnessHigh',
			},
			autoLoanCollectionPage: {
				id: 'autoLoanDisbursemetPage',
				text: 'Auto Loan Collection',
				path: '/collectionPages/autoLoanCollection',
				icon: 'DirectionsCar',
			},
			collectionApprovePage: {
				id: 'collectionApprove',
				text: 'Collection Approve',
				path: '/operations/collectionApprove',
				icon: 'Approval',
			},
			lineSeparatorClose: {
				id: 'lineSeparatorClose',
				text: '────────────────────',
				icon: undefined,
				isView: true,
			},
			closeLoanAdvancePage: {
				id: 'closeLoanAdvance',
				text: 'Close Loan Advance',
				path: '/operations/closeLoanAdvance',
				icon: 'AssignmentReturn',
			},
			closeLoanPage: {
				id: 'closeLoan',
				text: 'Close Loan',
				path: '/operations/closeLoan',
				icon: 'ExitToApp',
			},
			goldCloseLoanPage: {
				id: 'goldCloseLoan',
				text: 'Gold Close Loan',
				path: '/operations/goldCloseLoan',
				icon: 'CancelPresentation',
			},
			preCloseLoanPage: {
				id: 'preCloseLoan',
				text: 'Pre Close Loan',
				path: '/operations/preCloseLoan',
				icon: 'LockClock',
			},
			transferBranchPage: {
				id: 'transferBranchPage',
				text: 'Transfer Branch',
				path: '/operations/transferBranch',
				icon: 'BrandingWatermark',
			},
			transferCenterPage: {
				id: 'transferCenter',
				text: 'Transfer Center',
				path: '/operations/transferCenter',
				icon: 'CenterFocusStrong',
			},
			transferFunderPage: {
				id: 'transferFunder',
				text: 'Transfer Funder',
				path: '/operations/transferFunder',
				icon: 'TransferWithinAStation',
			},
			endOfDayPage: {
				id: 'endOfDay',
				text: 'End Of Day',
				path: '/operations/endOfDay',
				icon: 'Today',
			},
			changeGroupOfficer: {
				id: 'changeGroupOfficer',
				text: 'Change Group Officer',
				path: '/operations/changeGroupOfficer',
				icon: 'Group',
			},
			changeMeetingDate: {
				id: 'ChangeMeetingDate',
				text: 'Change Meeting Date',
				path: '/operations/ChangeMeetingDate',
				icon: 'ChangeCircle',
			},
			lastEMIDetails: {
				id: 'lastEMIDetails',
				text: 'Last EMI Details',
				path: '/operations/lastEMIDetails',
				icon: 'ReceiptLong',
			},
			nachUMRNlink: {
				id: 'nachUMRNlink',
				text: 'nach UMRN Link',
				path: '/operations/nachUMRNlink',
				icon: 'Link',
			},
		},
	},
};
/**************** OPEARTION PAGE MENU END *********************** */

/**************** REPORT PAGE MENU START *********************** */
export const reportsPageMenu = {
	reportsPages: {
		id: 'reports',
		text: 'Reports',
		path: '/reports',
		icon: 'ReportProblem',
		isView: true,
		subMenu: {
			requestReport: {
				id: 'requestReport',
				text: 'Request Report',
				path: '/reports/requestReport',
				icon: 'InsertDriveFile',
			},
			loanDisbursement: {
				id: 'loanDisbursement',
				text: 'Loan Disbursement',
				path: '/reports/loanDisbursement',
				icon: 'DoneAll',
			},
			demandCollectionReport: {
				id: 'demandCollectionReport',
				text: 'Demand Collection',
				path: '/reportPages/demandCollectionReport',
				icon: 'Collections',
			},
			futureDemandReport: {
				id: 'futureDemandReport',
				text: 'Future Demand Report',
				path: '/reportPages/futureDemandReport',
				icon: 'NewReleases',
			},
			MemberDetailsReport: {
				id: 'memberDetailsReport',
				text: 'Member Details Report',
				path: '/report/member-details-report',
				icon: 'People',
			},
			portfolioReport: {
				id: 'portfolioReport',
				text: 'Portfolio Report',
				path: '/report/portfolio',
				icon: 'UploadFile',
			},
			centerWiseReport: {
				id: 'centerWiseReport',
				text: 'Center Wise Report',
				path: '/report/centerWiseReport',
				icon: 'Assignment',
			},
			OverDueReport: {
				id: 'overDueReport',
				text: 'OverDue Report',
				path: '/report/overDueReport',
				icon: 'AssignmentLate',
			},
			PortFolioAtRiskReport: {
				id: 'PortFolioAtRiskReport',
				text: 'Portfolio At Risk Report',
				path: '/reportPages/portFlioAtRiskReport',
				icon: 'Dangerous',
			},
			branchDCBReport: {
				id: 'BranchDCBReport',
				text: 'Branch DCB Report',
				path: '/reportPages/branchDCBReport',
				icon: 'LocalConvenienceStore',
			},
			branchProfileReport: {
				id: 'branchProfileReport',
				text: 'Branch Profile',
				path: '/report/branchProfile',
				icon: 'GridView',
			},
			loanCardReport: {
				id: 'loanCardReport',
				text: 'Loan Card',
				path: '/report/LoanCardReport',
				icon: 'CardMembership',
			},
			DemandFollowupReport: {
				id: 'DemandFollowupReport',
				text: 'Demand Follow Up',
				path: '/reportPages/DemandFollowupReport',
				icon: 'Collections',
			},
			ArrearFollowupReport: {
				id: 'arrearFollowupReport',
				text: 'Arrear Follow Up',
				path: '/reportPages/ArrearFollowupReport',
				icon: 'Preview',
			},
			promiseToPayReport: {
				id: 'promiseToPayReport',
				text: 'Promise To Pay',
				path: '/reportPages/promiseToPayReport',
				icon: 'Payments',
			},
			DailyCollectionReport: {
				id: 'DailyCollectionReport',
				text: 'Daily Collection Report',
				path: '/reportPages/DailyCollectionReport',
				icon: 'CalendarToday',
			},
			repaymentCollectionReport: {
				id: 'repaymentCollectionReport',
				text: 'Repayment Collection',
				path: '/reportPages/repaymentCollectionReport',
				icon: 'Repeat',
			},
			goldLoanCollectionReport: {
				id: 'goldLoanCollectionReport',
				text: 'Gold Loan Collection Report',
				path: '/reportPages/goldLoanCollectionReport',
				icon: 'BrightnessHigh',
			},

			goldLoanStockReport: {
				id: 'goldLoanStockReport',
				text: 'Gold Stock Report',
				path: '/reportPages/goldLoanStackReport',
				icon: 'Inventory2',
			},
			walletReport: {
				id: 'walletReport',
				text: 'Wallet Collection',
				path: '/reportPages/walletReport',
				icon: 'AccountBalanceWallet',
			},
			thriftReport: {
				id: 'thriftReport',
				text: 'Thrift Report',
				path: '/reportPages/thriftReport',
				icon: 'Savings',
			},
			branchCollectionReport: {
				id: 'branchCollectionReport',
				text: 'Branch Collection',
				path: '/reportPages/branchCollectionReport',
				icon: 'AccountTree',
			},
			DayBookReport: {
				id: 'DayBookReport',
				text: 'Day Book',
				path: '/reportPages/DayBookReport',
				icon: 'Book',
			},
			centerDCBReport: {
				id: 'CenterDCBReport',
				text: 'Center DCB Report',
				path: '/reportPages/centerDCBReport',
				icon: 'FilterCenterFocus',
			},
			eodReport: {
				id: 'eodReport',
				text: 'End Of Day Report ',
				path: '/reportPages/eodReport',
				icon: 'Today',
			},
			preclosedLoanReport: {
				id: 'preclosedLoanReport',
				text: 'Pre Close Report',
				path: '/reportPages/preclosedLoanReport',
				icon: 'LockClock',
			},
			closedLoanReport: {
				id: 'closedLoanReport',
				text: 'Closed Loan Details',
				path: '/reportPages/closedLoanReport',
				icon: 'ExitToApp',
			},
			DeadMemberDetails: {
				id: 'DeadMemberDetails',
				text: 'Dead Member Report',
				path: '/reportPages/DeadMemberDetails',
				icon: 'PersonOff',
			},
			memberAccountReport: {
				id: 'memberAccountReport',
				text: 'Member Account',
				path: '/reportPages/memberAccountReport',
				icon: 'PersonPin',
			},
			savingsFollowupReport: {
				id: 'savingsFollowupReport',
				text: 'Savings Follow Up',
				path: '/reportPages/savingsFollowupReport',
				icon: 'savings',
			},
			attendanceReport: {
				id: 'attendanceReport',
				text: 'Staff Report',
				path: '/reportPages/attendanceReport',
				icon: 'LibraryBooks',
			},
			memberAttendanceReport: {
				id: 'memberAttendanceReport',
				text: 'Member Attendance Report',
				path: '/reportPages/memberAttendanceReport',
				icon: 'PersonAddAlt',
			},
			groupReport: {
				id: 'groupReport',
				text: 'Group Report',
				path: '/reportPages/groupReport',
				icon: 'Groups',
			},
			groupOfficerReport: {
				id: 'groupOfficerReport',
				text: 'Group Officer Report',
				path: '/reports/groupOfficerReport',
				icon: 'ManageAccounts',
			},
			progressReport: {
				id: 'progressReport',
				text: 'Progress Report',
				path: '/reportPages/progressReport',
				icon: 'ShowChart',
			},
			monthlyprogressReport: {
				id: 'monthlyprogressReport',
				text: 'Monthly Progress Report',
				path: '/reportPages/monthlyprogressReport',
				icon: 'CalendarViewMonth',
			},
			activeMemberReport: {
				id: 'activeMemberReport',
				text: 'Active Member',
				path: '/reportPages/activeMemberReport',
				icon: 'AccessibilityNew',
			},
			inActiveMemberReport: {
				id: 'inActiveMemberReport',
				text: 'Inactive Member',
				path: '/reportPages/inActiveMemberReport',
				icon: 'NotAccessible',
			},
			NpaReport: {
				id: 'NpaReport',
				text: 'NPA Report',
				path: '/reportPages/NpaReport',
				icon: 'GppBad',
			},
			goldArrearReport: {
				id: 'goldLoanArrearReport',
				text: 'Gold Loan Arrear Report',
				path: '/reportPages/goldloanarrearreport',
				icon: 'BrightnessHigh',
			},
			goldLoanInterestReminderReport: {
				id: 'goldLoanInterestReminderReport',
				text: 'Gold Loan Interest Reminder',
				path: '/reportPages/goldLoanInterestReminderReport',
				icon: 'Notifications',
			},
			ChangeMeetingReport: {
				id: 'ChangeMeetingReport',
				text: 'Change Meeting Report',
				path: '/reportPages/ChangeMeetingReport',
				icon: 'ChangeCircle',
			},
			auditingToolReport: {
				id: 'auditingToolReport',
				text: 'Auditing Tool Report',
				path: '/reportPages/auditingToolReport',
				icon: 'QuestionAnswer',
			},
			sanctionReport: {
				id: 'sanctionReport',
				text: 'Sanction Report',
				path: '/reportPages/sanctionReport',
				icon: 'Approval',
			},
			kycSourcedReport: {
				id: 'kycSourcedReport',
				text: 'KYC Sourced Report',
				path: '/reportPages/kycSourcedReport',
				icon: 'SafetyDivider',
			},
			insuranceReport: {
				id: 'insuranceReport',
				text: 'Insurance Report',
				path: '/reportPages/insuranceReport',
				icon: 'CreditCard',
			},
			monthWiseInterestSummaryReport: {
				id: 'monthWiseInterestSummaryReport',
				text: 'Month Wise Interest Summary Report',
				path: '/reportPages/monthWiseInterestSummaryReport',
				icon: 'NotificationImportant',
			},
			staffDetailReport: {
				id: 'staffDetailReport',
				text: 'Staff Report',
				path: '/reportPages/staffDetailReport',
				icon: 'SupervisorAccount',
			},
			qrReport: {
				id: 'qrReport',
				text: 'QR Report',
				path: '/reportPages/qrReport',
				icon: 'QrCode',
			},
			enachReport: {
				id: 'enachReport',
				text: 'Enach Report',
				path: '/reportPages/enachReport',
				icon: 'Link',
			},
			mandateReport: {
				id: 'mandateReport',
				text: 'Mandate Report',
				path: '/reportPages/mandateReport',
				icon: 'AutoFixNormal',
			},
			goldPriceReport: {
				id: 'goldPriceReport',
				text: 'Gold Price',
				path: '/reportPages/goldpricereport',
				icon: 'StarRate',
			},
			// memberRejectionReport: {
			// 	id: 'memberRejectionReport',
			// 	text: 'Member Rejection Report',
			// 	path: '/reportPages/memberRejectionReport',
			// 	icon: 'People',
			// },
			// AuditTrailReport: {
			// 	id: 'AuditTrailReport',
			// 	text: 'Audit Trail Report',
			// 	path: '/reportPages/AuditTrailReport',
			// 	icon: 'FormatListNumbered',
			// },
			// postAuditingToolReport: {
			// 	id: 'postAuditingToolReport',
			// 	text: 'Post Auditing Tool Report',
			// 	path: '/reportPages/postAuditingToolReport',
			// 	icon: 'AccountTree',
			// },
			// leadReport: {
			// 	id: 'leadReport',
			// 	text: 'Lead Report',
			// 	path: '/reportPages/leadReport',
			// 	icon: 'FormatListNumbered',
			// },
			officerLocationReport: {
				id: 'officerLocationReport',
				text: 'Officer Location Report',
				path: '/reportPages/officerLocationReport',
				icon: 'PersonPinCircle',
			},
			AutoCollectionPageReport: {
				id: 'AutoCollectionPageReport',
				text: 'Auto Loan Collection Report',
				path: '/reportPages/AutoCollectionPageReport',
				icon: 'DirectionsBus',
			},
			CreditBureauReport: {
				id: 'CreditBureauReport',
				text: 'Credit Bureau Report',
				path: '/reportPages/creditBureauReport',
				icon: 'CreditScore',
			},
			DataVerificationReport: {
				id: 'DataVerificationReport',
				text: 'Data Verification Report',
				path: '/reportPages/dataVerificationReport',
				icon: 'Verified',
			},
			AccuredInterestReport: {
				id: 'AccuredInterestReport',
				text: 'Accured Interest Report',
				path: '/reportPages/accuredInterestReport',
				icon: 'PostAdd',
			},
			// CollectionFormatReport: {
			// 	id: 'CollectionFormatReport',
			// 	text: 'Collection Format Report',
			// 	path: '/reportPages/collectionFormatReport',
			// 	icon: 'DirectionsBus',
			// },
			// BranchSummaryReport: {
			// 	id: 'BranchSummaryReportPage',
			// 	text: 'Branch Summary Report',
			// 	path: '/reportPages/branchSummaryReport',
			// 	icon: 'DirectionsBus',
			// },
			VehicleSeizedReport: {
				id: 'VehicleSeizedReport',
				text: 'Vehicle Seized Report',
				path: '/reportPages/vehicleSeizedReport',
				icon: 'CarRepair',
			},
			DealerReport: {
				id: 'DealerReport',
				text: 'Dealer Report',
				path: '/reportPages/dealerReport',
				icon: 'PersonSearch',
			},
		},
	},
};
/**************** REPORT PAGE MENU END *********************** */

/**************** PROFILE PAGE MENU START *********************** */
export const profilePageMenu = {
	profile: {
		id: 'profile',
		text: 'Profile',
		path: 'profile/profilePage',
		icon: 'profile',
	},
};
/**************** PROFILE PAGE MENU END *********************** */

/**************** LOGIN PAGE MENU START *********************** */
export const loginPages = {
	login: {
		id: 'login',
		text: 'Login',
		path: 'auth-pages/login',
		icon: 'Login',
		hide: true,
	},
	dashboard: {
		id: 'dashboard',
		text: 'Dashboard',
		path: '/',
		icon: 'Dashboard',
		hide: true,
	},
	signUp: {
		id: 'signUp',
		text: 'Sign Up',
		path: 'auth-pages/sign-up',
		icon: 'PersonAdd',
		hide: true,
	},

	page404: {
		id: 'Page404',
		text: '404 Page',
		path: 'auth-pages/404',
		icon: 'ReportGmailerrorred',
		hide: true,
	},
};
/**************** LOGIN PAGE MENU END *********************** */

/**************** FINANCE PAGE MENU START *********************** */
export const financePageMenu = {
	financePages: {
		id: 'finance',
		text: 'Finance',
		path: '/finance',
		icon: 'Inbox',
		isView: true,

		subMenu: {
			masterHead: {
				id: 'Master',
				text: 'MASTER',
				icon: undefined,
				isView: true,
				className: 'menu-header-large',
			},
			lineSeparatorStart: {
				id: 'lineSeparatorStart',
				text: '────────────────────',
				icon: undefined,
				isView: true,
			},
			GroupAccount: {
				id: 'GroupAccount',
				text: 'Group Account',
				path: '/financePages/groupAccount',
				icon: 'Groups',
				isView: true,
			},
			SubGroupAccount: {
				id: 'SubGroupAccount',
				text: 'SubGroupAccount',
				path: '/financePages/subGroupAccount',
				icon: 'GroupWork',
				isView: true,
			},
			Accounts: {
				id: 'Accounts',
				text: 'Account',
				path: '/financePages/accounts',
				icon: 'AccountBox',
				isView: true,
			},
			GstType: {
				id: 'GstType',
				text: 'GST Type',
				path: '/financePages/gstType',
				icon: 'AttachMoney',
				isView: true,
			},
			OpeningBalance: {
				id: 'OpeningBalance',
				text: 'Opening Balance',
				path: '/financePages/OpeningBalance',
				icon: 'AccountBalanceWallet',
				isView: true,
			},
			Instrument: {
				id: 'Instrument',
				text: 'Instrument',
				path: '/financePages/instrument',
				icon: 'WebAsset',
				isView: true,
			},
			AccountMapping: {
				id: 'Account Mapping',
				text: 'Account Mapping',
				path: '/financePages/accountMapping',
				icon: 'AccountTree',
				isView: true,
			},
			TransactionHead: {
				id: 'Transaction',
				text: 'TRANSACTION',
				icon: undefined,
				isView: true,
				className: 'menu-header-large',
			},
			lineSeparatorTrsactionStart: {
				id: 'lineSeparatorTrsactionStart',
				text: '────────────────────',
				icon: undefined,
				isView: true,
			},
			CashTransaction: {
				id: 'Cash Transaction',
				text: 'Cash Transactions',
				path: '/financePages/cashTransaction',
				icon: 'Money',
				isView: true,
			},

			BankTransaction: {
				id: 'BankTransaction',
				text: 'Bank Transactions',
				path: '/financePages/BankTransaction',
				icon: 'Business',
				isView: true,
			},
			JournalTransaction: {
				id: 'Journal Transaction',
				text: 'Journal Transactions',
				path: '/financePages/journalTransaction',
				icon: 'SupportAgent',
				isView: true,
			},
			reportHead: {
				id: 'Report',
				text: 'REPORT',
				icon: undefined,
				isView: true,
				className: 'menu-header-large',
			},
			lineSeparatorStart2: {
				id: 'lineSeparatorStart2',
				text: '────────────────────',
				icon: undefined,
				isView: true,
			},
			LedgerReports: {
				id: 'LedgerReports',
				text: 'Ledger Reports',
				path: '/financePages/LedgerReports',
				icon: 'MenuBook',
				isView: true,
			},
			TrailBalance: {
				id: 'Trial Balance',
				text: 'Trial Balance',
				path: '/reportPages/trialBalanceReport',
				icon: 'AccountBalanceWallet',
			},
			profitAndLossReport: {
				id: 'profitAndLossReport',
				text: 'Profit & Loss',
				path: '/reportPages/profitAndLossReport',
				icon: 'TableChart',
			},
			ReceiptsPayments: {
				id: 'ReceiptsPayments',
				text: 'Receipts & Payments',
				path: '/financePages/ReceiptsPayments',
				icon: 'Receipt',
				isView: true,
			},
			BalanceSheet: {
				id: 'BalanceSheet',
				text: 'Balance Sheet',
				path: '/financePages/BalanceSheet',
				icon: 'BackupTable',
				isView: true,
			},
			DayBookReport: {
				id: 'DayBookReport',
				text: 'Day Book',
				path: '/financePages/DayBookReport',
				icon: 'Book',
				isView: true,
			},
		},
	},
};
/**************** FINANCE PAGE MENU END *********************** */
